import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ModalVideo from '@/ui/modal-video';
import linkStyles from '@/ui/links/links.module.scss';

const propTypes = {
  variant: PropTypes.string,
  customAttributes: PropTypes.object,
  copyBtn: PropTypes.string,
  ariaLabel: PropTypes.string,
  channel: PropTypes.string,
  ratio: PropTypes.string,
  openName: PropTypes.string,
  videoId: PropTypes.string.isRequired,
  buttonPositionClass: PropTypes.string,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({current: PropTypes.any})]),
  transcript: PropTypes.string
};

class ModalButton extends Component {
  constructor() {
    super();

    this.state = {
      openName: false
    };
    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({openName: true});
  }

  render() {
    const {
      variant = null,
      customAttributes = {},
      innerRef,
      channel,
      ratio,
      openName,
      videoId,
      buttonPositionClass,
      ariaLabel,
      copyBtn,
      transcript
    } = this.props;
    const {openName: isOpen} = this.state;

    // Link variant for standalone play button (not placed on an image). Style resembles the primary link variant.
    const hoverEffectVariants = ['primary-play-btn', 'secondary-play-btn', 'secondary-sm-no-arrow'];

    const isLinkVariant = variant && hoverEffectVariants.includes(variant);

    const buttonPositionClassComputed = cx({
      'on-image': variant === 'image',
      'on-image-green': variant === 'image-green',
      'on-image-neutral50': variant === 'image-neutral50',
      [linkStyles.link]: isLinkVariant,
      [linkStyles[`link-${variant}`]]: isLinkVariant
    });

    return (
      <>
        <ModalVideo
          channel={channel || 'wistia'}
          ratio={ratio}
          openName={openName}
          isOpen={isOpen}
          videoId={videoId}
          buttonPositionClass={buttonPositionClass}
          transcript={transcript}
          onClose={() => {
            this.setState({openName: false});
          }}
          data-testid="modal-video"
        />

        <button
          data-testid="modal-button-trigger"
          aria-label={ariaLabel || 'Play video'}
          ref={innerRef}
          type="button"
          onClick={this.openModal}
          className={buttonPositionClassComputed}
          {...customAttributes}>
          {isLinkVariant ? (
            <>
              <span className={linkStyles.foreground}>{copyBtn}</span>
              <span className={linkStyles['background-wrapper']}>
                <span className={linkStyles.background} />
              </span>
            </>
          ) : (
            copyBtn
          )}
        </button>
      </>
    );
  }
}

ModalButton.propTypes = propTypes;

export default React.forwardRef((props, ref) => <ModalButton {...props} innerRef={ref} />);
